import React from "react";

import HeadingWithIcon from "Components/landing_page/HeadingWithIcon";

import { AboutIntroContainer } from "./AboutIntro.style";

const AboutIntro = () => {
	return (
		<AboutIntroContainer>
			<div className="aboutintro_main">
				<div className="mygrid-container">
					<div className="mygrid-row">
						<div className="mygrid-col-md-12">
							<div className="about_intro_content">
								<div className="plans_intro_content_left">
									<h5 className="subheading">Plans & Pricing</h5>
									<HeadingWithIcon highlight="Our Plans">About</HeadingWithIcon>
								</div>
								<div className="plans_intro_content_right">
									<h3 className="plans_intro_content_right_heading">Choose Your Plan. Transform Your Classroom.</h3>
									<p className="plans_intro_content_right_description">
										<strong>Subjects Master offers flexible subscription plans designed to meet the needs of every learning environment.</strong>
										Whether you’re a solo teacher looking to engage your students, part of a homeschool network seeking more collaboration, or managing a full school campus that
										requires powerful administrative tools, we have a plan built for you. Each tier delivers interactive learning, real-time insights, and the flexibility to help
										your learners master any subject with confidence.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</AboutIntroContainer>
	);
};

export default AboutIntro;
